export const pokedexGen8 = {
  "pokedex810": "Chimpep",
  "pokedex811": "Chimstix",
  "pokedex812": "Gortrom",
  "pokedex813": "Hopplo",
  "pokedex814": "Kickerlo",
  "pokedex815": "Liberlo",
  "pokedex816": "Memmeon",
  "pokedex817": "Phlegleon",
  "pokedex818": "Intelleon",
  "pokedex819": "Raffel",
  "pokedex820": "Schlaraffel",
  "pokedex821": "Meikro",
  "pokedex822": "Kranoviz",
  "pokedex823": "Krarmor",
  "pokedex824": "Sensect",
  "pokedex825": "Keradar",
  "pokedex826": "Maritellit",
  "pokedex827": "Kleptifux",
  "pokedex828": "Gaunux",
  "pokedex829": "Cottini",
  "pokedex830": "Cottomi",
  "pokedex831": "Wolly",
  "pokedex832": "Zwollock",
  "pokedex833": "Kamehaps",
  "pokedex834": "Kamalm",
  "pokedex835": "Voldi",
  "pokedex836": "Bellektro",
  "pokedex837": "Klonkett",
  "pokedex838": "Wagong",
  "pokedex839": "Montecarbo",
  "pokedex840": "Knapfel",
  "pokedex841": "Drapfel",
  "pokedex842": "Schlapfel",
  "pokedex843": "Salanga",
  "pokedex844": "Sanaconda",
  "pokedex845": "Urgl",
  "pokedex846": "Pikuda",
  "pokedex847": "Barrakiefa",
  "pokedex848": "Toxel",
  "pokedex849": "Riffex",
  "pokedex850": "Thermopod",
  "pokedex851": "Infernopod",
  "pokedex852": "Klopptopus",
  "pokedex853": "Kaocto",
  "pokedex854": "Fatalitee",
  "pokedex855": "Polteageist",
  "pokedex856": "Brimova",
  "pokedex857": "Brimano",
  "pokedex858": "Silembrim",
  "pokedex859": "Bähmon",
  "pokedex860": "Pelzebub",
  "pokedex861": "Olangaar",
  "pokedex862": "Barrikadax",
  "pokedex863": "Mauzinger",
  "pokedex864": "Gorgasonn",
  "pokedex865": "Lauchzelot",
  "pokedex866": "Pantifrost",
  "pokedex867": "Oghnatoll",
  "pokedex868": "Hokumil",
  "pokedex869": "Pokusan",
  "pokedex870": "Legios",
  "pokedex871": "Britzigel",
  "pokedex872": "Snomnom",
  "pokedex873": "Mottineva",
  "pokedex874": "Humanolith",
  "pokedex875": "Kubuin",
  "pokedex876": "Servol",
  "pokedex877": "Morpeko",
  "pokedex878": "Kupfanti",
  "pokedex879": "Patinaraja",
  "pokedex880": "Lectragon",
  "pokedex881": "Lecrydon",
  "pokedex882": "Pescragon",
  "pokedex883": "Pescrydon",
  "pokedex884": "Duraludon",
  "pokedex885": "Grolldra",
  "pokedex886": "Phandra",
  "pokedex887": "Katapuldra",
  "pokedex888": "Zacian",
  "pokedex889": "Zamazenta",
  "pokedex890": "Endynalos",
  "pokedex891": "Wulaosu",
  "pokedex892": "Shifours",
  "pokedex893": "Zarude",
  "pokedex894": "Regieleki",
  "pokedex895": "Regidrago",
  "pokedex896": "Polaross",
  "pokedex897": "Phantoross",
  "pokedex898": "Coronospa",
};